import React from 'react';
import { SuccessCheckIcon } from '../../../assets/iconComponents/SuccessCheckIcon';
import { useSuccess } from '../../../contexts/SuccessContext';
import { Button } from '../buttons/Button';

/**
 * Asks user to confirm that an action was successful. Works with the Success Context, so the modal can be used throughout the app.
 * 
 * @returns {JSX.Element}
 * 
 * @category Components - UI
 */
export const SuccessDialog = () => {
    const {success, successMessage, blurBG, hideSuccess, requestConfirmSuccess, setRequestConfirmSuccess} = useSuccess();

    if(!success) return null;

    const handleRequestConfirm = () => {
        hideSuccess()
        setRequestConfirmSuccess(false)
    }

    return (
        <>
            {blurBG &&
                <div className={`h-screen w-screen fixed inset-0 z-10 transition-opacity opacity-75 bg-black bg-opacity-50 backdrop-filter backdrop-blur-md`}></div>
            }
            <div className='fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 bg-white rounded-md border border-black'>
                <div className='m-auto bg-white min-h-36 min-w-36 max-w-72 max-h-min z-10 border flex flex-col rounded-md shadow-xl p-4'>
                    <h1 className='w-full text-center font-Poppins-Med text-tcbGreen mt-7'>{successMessage}</h1>
                    <div className='m-auto'>
                        <SuccessCheckIcon width='60' height='60' />
                    </div>

                    {requestConfirmSuccess ? (
                        <div className='self-center my-2'>
                            <Button variant='primary' onClick={() => handleRequestConfirm()}>Okay</Button>
                        </div>
                    ) : null}
                </div>
            </div>
        </>
    )
}